<template>
  <el-card shadow="never">
    <el-page-header @back="goBack">
      <template slot="content">
        <div>当前：{{ course_name }}</div>
      </template>
    </el-page-header>
    <el-divider></el-divider>
    <!-- 添加俱乐部 -->
    <div>
      <el-button @click="openDialogAddOp" size="mini" type="primary">
        添加俱乐部
      </el-button>
    </div>

    <!-- 俱乐部表 -->
    <el-table :data="club_data" style="width: 100%">
      <el-table-column prop="surf_loaction" label="" width="180">
      </el-table-column>
      <el-table-column prop="club_name" label="" width="180"> </el-table-column>
      <el-table-column prop="" label=""> </el-table-column>
      <el-table-column prop="update_time" label="">
        <template slot-scope="operator">
          <el-link
            @click="manageCourseConent(operator.row.course_id)"
            :underline="false"
            >内容管理</el-link
          >
          ｜<el-link :underline="false">编辑</el-link> ｜<el-link
            :underline="false"
            >下线</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 对话框 -->
    <operator-list
      ref="formOperatorInfo"
      @getOperatorId="getOperatorId"
      @getOperatorInfo="getOperatorInfo"
      :showDialogOperatorInfo.sync="showDialogOperatorInfo"
    ></operator-list>
  </el-card>
</template>

<script>
import SpuList from "../../components/product/SpuList";

export default {
  name: "course_club_manage",
  components: {
    "operator-list": SpuList,
  },
  data() {
    return {
      showDialogOperatorInfo: false, // 对话框
      course: "",
      course_name: "",
      club_data: [],
    };
  },
  mounted() {
    if (this.$route.params.course) {
      this.course = this.$route.params.course;
      this.course_name = this.$route.params.course.course_name;
      //   console.log(this.course);
      // 请求该课程所有俱乐部，已目的地为准
    } else {
      this.$router.push({ name: "course" });
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "course" });
    },
    openDialogAddOp() {
      this.showDialogOperatorInfo = true;
    },
    // 选择服务商并添加到课程
    // 单选添加
    getOperatorId(value) {
      this.$http
        .get(
          `/add_dest_club?spu_id=${value}&course_id=${this.course.course_id}`
        )
        .then((res) => {
          if (res.data.errno == "0") {
            this.$notify({
              title: "成功",
              message: res.data.errmsg,
              type: "success",
            });
            this.showDialogOperatorInfo = false;
          } else {
            this.$notify.error({
              title: "出错",
              message: res.data.errmsg,
            });
          }
        });
    },
    // 多选添加
    getOperatorInfo(value1, value2) {
      this.$http
        .get(
          `/add_dest_club?spu_id=${value1}&course_id=${this.course.course_id}`
        )
        .then((res) => {
          if (res.data.errno == "0") {
            this.$notify({
              title: "成功",
              message: res.data.errmsg,
              type: "success",
            });
            this.showDialogOperatorInfo = false;
          } else {
            this.$notify.error({
              title: "出错",
              message: res.data.errmsg,
            });
          }
        });
    },
  },
};
</script>

<style>
</style>